import { render, staticRenderFns } from "./createProductDialog.vue?vue&type=template&id=83ac98c2&scoped=true"
import script from "./createProductDialog.vue?vue&type=script&lang=js"
export * from "./createProductDialog.vue?vue&type=script&lang=js"
import style0 from "./createProductDialog.vue?vue&type=style&index=0&id=83ac98c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac98c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83ac98c2')) {
      api.createRecord('83ac98c2', component.options)
    } else {
      api.reload('83ac98c2', component.options)
    }
    module.hot.accept("./createProductDialog.vue?vue&type=template&id=83ac98c2&scoped=true", function () {
      api.rerender('83ac98c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/addProductDialog/createProductDialog.vue"
export default component.exports